import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function EvoLiveRewardsPromo(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // const brandName = (brandId === 33 || brandId === 34) ? 'IW247' : (brandId === 39 || brandId === 40) ? 'Fomo7' : (brandId === 46 || brandId === 47) ? 'Fun88' : 'Yolo247';
    const is_crypto = (brandId == 61)

    return (
        <>
            <InformationWrapper>
                <TitleConatiner>
                    <h2>Evolution Live Rewards &#45; Play Big, Get Assured Wins</h2>
                    <p>Enjoy <strong>premium live casino action</strong> on <strong>Evolution Lightning Roulette & Crazy Time</strong>.<br />Place <strong>qualifying bets</strong> and receive <strong>assured free bets</strong> as rewards.</p>
                    {/* <Link to='/member/finance/deposit'>Deposit Now</Link> */}
                    <GameBlock>
                        <Link to="/live-casino/evolution/live-roulette">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.GameOne}`}
                                alt="Lightning Roulette"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                        <Link to="/live-casino/evolution/crazy-time">
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.GameTwo}`}
                                alt="Crazy Time"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                        </Link>
                    </GameBlock>
                </TitleConatiner>
                <br />
                <h2>How to Participate</h2>
                <br />
                <Container>
                    <LeftCardWrapper>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.EvoLiveRewrdsIconOne}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            {/* <p><strong>Keep depositing on {brandName}</strong></p> */}
                            <p><strong>Play Evolution Lightning Roulette & Crazy Time</strong></p>
                        </LeftCard>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.EvoLiveRewrdsIconTwo}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p>Place <strong>cumulative<br /> bets of {is_crypto ? "$2,026" : "₹20,260"}</strong></p>
                        </LeftCard>
                        <LeftCard>
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.EvoLiveRewrdsIconThree}`}
                                alt="Aviator26FBB"
                                effect="none"
                                placeholder={<PlaceholderImage />}
                            />
                            <p><strong>Receive assured<br /> free bets</strong></p>
                        </LeftCard>
                    </LeftCardWrapper>
                </Container>

                <Container>
                    <TermsImageWrapper>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.EvoLiveRewrdsTermsImg}`}
                            alt="Aviator26FBB"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </TermsImageWrapper>
                    <RightCradWrapper>
                        <RightCard><p>Valid from <strong>01 Jan 2026 to 28 Feb 2026</strong></p></RightCard>
                        <RightCard><p><strong>Applicable only on Evolution Lightning Roulette & Crazy Time</strong></p></RightCard>
                        <RightCard><p><strong>Free bets up to {is_crypto ? "$203" : "₹2,026"}</strong></p></RightCard>
                        <RightCard><p><strong>Claimable up to 3 times per user per week</strong></p></RightCard>
                        <RightCard><p>Bonus credited <strong>after completion of qualifying wagers</strong></p></RightCard>
                        <RightCard><p>Free bets usable  <strong>only on Evolution games</strong></p></RightCard>
                        <RightCard><p><strong>Bonus wagering requirements apply</strong></p></RightCard>
                        <RightCard><p><strong>Estimated total promotion pool: {is_crypto ? "$100,000" : "₹1,00,00,000"}</strong></p></RightCard>
                        <RightCard><p><strong>Eligible tables or games may change</strong> without prior notice</p></RightCard>
                        <RightCard><p><strong>General Live Casino terms & conditions apply</strong></p></RightCard>
                    </RightCradWrapper>
                </Container>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(EvoLiveRewardsPromo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.EvoLiveRewrdsPromoMainInnerBg")});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    color: #fff;
    text-transform: capitalize;

    h2 {
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-family: 'Inter-Bold';
        line-height: normal;
        text-transform: capitalize;
        margin: 0;
        background: linear-gradient(360deg, #dec27f 21.12%, #ffc63d 54.72%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
`;

const TitleConatiner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.2rem;
    padding: 1rem 0;

    p {
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-transform: capitalize;
        margin: 0;
    }
`;

const GameBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    a {
        cursor: pointer;
        width: 178px;
         img {
            max-width: 100%;
         }
    }
`;

const Container = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    padding: 1rem 1rem 2rem 1rem;
`;

const LeftCardWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
`;

const LeftCard = styled.div`
    width: 33.33%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    border-radius: 9.556px;
    border: 1px solid #989098;
    background: rgba(255, 255, 255, 0.10);
    backdrop-filter: blur(7.5px);
    padding: 1.5rem 2.5rem 1.5rem 2.5rem;

    img {
        width: 55px;
    }

    p {
        width: 85%;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        text-align: left;
        font-weight: 400;
        line-height: 21px;
        text-transform: capitalize;
        margin: 0;
    }
`;

const TermsImageWrapper = styled.div`
    display: flex;
    text-align: right;
    justify-content: center;
    align-items: flex-start;
    flex: 0 0 45%;

    img {
        width: 60%;
        align-self: flex-end;
    }
`;

const RightCradWrapper = styled.ul`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    flex: 1;
    gap: 10px;
    margin: 0;
    padding: 0;
`;

const RightCard = styled.li`
    width: 70%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    background: #433C33;
    padding: 5px 25px;

    p {
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
        text-transform: capitalize;
        margin: 0;
    }
`;
